import { Stack, Typography, Box, } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import LockerTypeListTable from './LockerTypeMangTable';
import AddIcon from '@mui/icons-material/Add';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import AddEditLockerTypeModal from './AddNewLockerTypeModal';
import { AddLookUpBtn } from '../../components/styledComponent/Button';
import { AppContext } from '../../contexts/AppContext';

const LockerTypeManagement = () => {
  const [open, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any | null>()
  const [LockerTypeList, setLockerTypeList] = useState<any | null>()
  const [count, setCount] = useState<any>(0);
  const [skip, setSkip] = useState<any>(0);
  const [take, setTake] = useState<any>(10);
  const [loading, setLoading] = useState<boolean>(false);
  const { user } = useContext(AppContext)

  const { get } = useCrudForm();

  const refetch = () => {
    get({
      endpoints: `${endpoints.lockerType.api}?skip=${skip * take}&take=${take}`,
      onSuccess: (data: any) => {
        setLockerTypeList(data.data.list)
        setCount(data.data.count)
        setLoading(false)
      },
      onError: (error: any) => {
        console.log(error)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    refetch()
  }, [skip, take])

  return (
    <>
      <Typography variant="h5" component="h5" mb={1} fontWeight={600}>Locker Type Management</Typography>
      <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        {
          user && (user?.role)?.toLowerCase() === 'admin' ?
            <Stack direction="row" justifyContent="flex-end" mb={2}>
              <AddLookUpBtn onClick={() => setOpen(true)} startIcon={<AddIcon />}>Add New</AddLookUpBtn>
            </Stack>
            : null
        }
        <LockerTypeListTable setOpen={setOpen} setSelectedItem={setSelectedItem} rows={LockerTypeList} loading={loading} count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} refetch={refetch} />
      </Box>
      <AddEditLockerTypeModal open={open} setOpen={setOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} refetch={refetch} />

    </>
  )
}

export default LockerTypeManagement
